import React from 'react'
import cx from 'classnames'
import PatchLink from './patch-link'
import withSend from 'microcosm/addons/with-send'

class SelectedLink extends React.PureComponent {
  static defaultProps = {
    query: {}
  }

  focus = e => {
    this.wasFocused = true
    this.props.send('focusChartShape', this.props.selected)

    e.stopPropagation()
  }

  blur = e => {
    if (this.wasFocused) {
      this.wasFocused = false
      this.props.send('blurChartShape')

      e.stopPropagation()
    }
  }

  componentWillUnmount() {
    if (this.wasFocused) {
      this.props.send('blurChartShape')
    }
  }

  render() {
    const {
      category,
      children,
      selected,
      className,
      query,
      track,
      trackAs,
      avoidHref = false
    } = this.props

    const classList = cx(className, 'selected-link', `category-${category}`)

    const eventHandlers = {
      onFocus: this.focus,
      onBlur: this.blur,
      onMouseOver: this.focus,
      onMouseOut: this.blur
    }

    return (
      <PatchLink
        className={classList}
        query={{ selected, category, ...query }}
        track={track}
        trackAs={trackAs}
        avoidHref={avoidHref}
        {...eventHandlers}
      >
        {children}
      </PatchLink>
    )
  }
}

export default withSend(SelectedLink)



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/selected-link.js